import styled from 'styled-components';
import {
  py, px, p, mb
} from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import theme from '@lib/theme';

export const StyledCover = styled.div`
  ${p(2)};
  ${mb(3)};
  padding-bottom: 2rem;
`;

export const StyledTopHeader = styled.div`
  background-color: #7ccde9;
  color: ${theme.colors.white};
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.25);
  font-size: 25px;
  font-weight: bold;
  ${p(4)};
  ${mb(1)}
  display: flex;
  flex-direction: row;
  ${breakpoint('mobile', 'desktop')`
    font-size: 18px;
      ${py(3)};
      ${px(2)}
`}
`;

export const StyledTitle = styled.div``;

export const StyledSubText = styled.div`
  font-size: 22px;
  font-weight: bold;
  color: ${theme.colors.mediumGray};
  ${p(3)};
  ${breakpoint('mobile', 'desktop')`
    font-size: 20px;
`}
`;

export const StyledCenterAlignWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledKnowMoreButton = styled.button`
  background-color: white;
  border: 2px solid #7ccde9;
  border-radius: 6px;
  ${p(2)};
  cursor: pointer;
  color: #7ccde9;
`;

export const StyledTableWrapper = styled.div`
  transition: all 3s;
  overflow: hidden;
`;

export const StyledSeprator = styled.hr`
  color: ${theme.colors.mediumGray};
  width: 100%;
  &:nth-last-child(1) {
    display: none;
  }
`;

export const StyledSeeMoreButton = styled.div`
  color: ${theme.colors.mediumGray};
  outline: none;
  font-size: 25px;
  ${p(2)};
  :hover {
    color: ${theme.colors.logoBlue};
  }
  ${breakpoint('mobile', 'desktop')`
    font-size: 20px;
  `}
  font-weight: bold;
  float: right;
  cursor: pointer;
`;
